import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatSizePipe } from './formatSizePipe';

@NgModule({
  declarations: [FormatSizePipe],
  imports: [CommonModule],
  exports: [FormatSizePipe],
})
export class FormatSizePipeModule {
}
